import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
 private readonly oidcSecurityService = inject(OidcSecurityService);

 
 isAuthenticated$ = this.oidcSecurityService.isAuthenticated$;
 accessToken: string = '';
    constructor(private router: Router) {
        this.isAuthenticated$.subscribe(() => {
            
            this.oidcSecurityService.getAccessToken(environment.authConfig).subscribe(token => {
                this.accessToken = token;
                console.log("Interceptor Token: " + token);
            }
            );
        });
    }

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // except for /login endpoint
        if (request.url.includes('/login')) {
            return next.handle(request);
        }
        if (this.accessToken) {
            request =  this.addToken(request, this.accessToken);
          }
      
          return next.handle(request);
    }

    private addToken(request: HttpRequest<unknown>, token: string) {
        return request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }

      

/*
intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // OIDC-Callback läuft? Dann nichts anfassen.
    const qs = typeof window !== 'undefined' ? window.location.search : '';
    const isCallback = qs.includes('code=') && qs.includes('state=');
    if (isCallback) return next.handle(req);

    // Login-/Authority-URLs nicht modifizieren
    if (req.url.includes('/login') || this.isAuthorityUrl(req.url) || isAppAsset(req.url)) {
      return next.handle(req);
    }

    return this.oidcSecurityService.getAccessToken().pipe(
      take(1),
      switchMap(token => {
        const authReq = token
          ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
          : req;
        return next.handle(authReq);
      })
    );
  }

  private isAuthorityUrl(url: string) {
    return url.startsWith('https://auth.staging.necta.one'); // ggf. aus deiner Config lesen
  }

  private isAppAsset(url: string) {
  return url.startsWith(location.origin) && (
    url.endsWith('.html') || url.includes('/assets/') || url.includes('/favicon')
  );
}*/

}